class ProgramCurriculumGrid {
  constructor(dom) {
    this.NAME = 'ProgramCurriculumGrid';
    this.dom = dom;
  }

  init() {
    this.dom.querySelectorAll('[data-curriculum-grid-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => this.toggle(toggle));
    });
  }

  toggle(toggle) {
    const course = toggle.closest('.program-curriculum-grid__course');
    if (!course) return;

    const isOpen = course.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

export default ProgramCurriculumGrid;
